"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLeftTeamNotificationSchema = exports.UserJoinedTeamNotificationSchema = exports.UserInvitedNotificationSchema = exports.UserLeftTeamNotificationPayloadSchema = exports.UserJoinedTeamNotificationPayloadSchema = exports.UserInvitedNotificationPayloadSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
/**
 * Notification payload types
 */
exports.UserInvitedNotificationPayloadSchema = (0, core_1.StrictObject)({
    invitationId: core_1.IdSchema,
    invitedUserId: typebox_1.Type.Optional(core_1.IdSchema),
    invitedUserEmail: typebox_1.Type.Optional(core_1.EmailSchema),
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
    invitedById: core_1.IdSchema,
    invitedByName: core_1.NameSchema,
});
exports.UserJoinedTeamNotificationPayloadSchema = (0, core_1.StrictObject)({
    joinedUserId: core_1.IdSchema,
    joinedUserName: core_1.NameSchema,
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
});
exports.UserLeftTeamNotificationPayloadSchema = (0, core_1.StrictObject)({
    leftUserId: core_1.IdSchema,
    leftUserName: core_1.NameSchema,
    teamId: core_1.IdSchema,
    teamName: core_1.NameSchema,
});
/**
 * Notification Types
 */
exports.UserInvitedNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.ACCOUNTS_USER_INVITED_TO_TEAM, exports.UserInvitedNotificationPayloadSchema);
exports.UserJoinedTeamNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.ACCOUNTS_USER_JOINED_TEAM, exports.UserJoinedTeamNotificationPayloadSchema);
exports.UserLeftTeamNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.ACCOUNTS_USER_LEFT_TEAM, exports.UserLeftTeamNotificationPayloadSchema);
